import { render, staticRenderFns } from "./DischargeRecord.vue?vue&type=template&id=bc41318c&scoped=true"
import script from "./DischargeRecord.vue?vue&type=script&lang=js"
export * from "./DischargeRecord.vue?vue&type=script&lang=js"
import style0 from "./DischargeRecord.vue?vue&type=style&index=0&id=bc41318c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc41318c",
  null
  
)

export default component.exports